/** API pode retornar { data: { totalItems, ... } } ou o objeto de totais direto. */
export const unwrapCalculateTotalResponse = (response: any) => {
  if (!response) return null

  if (
    response.totalItems != null ||
    response.total != null ||
    response.totalAdditional != null
  ) {
    return response
  }

  const nested = response.data
  if (
    nested &&
    (nested.totalItems != null ||
      nested.total != null ||
      nested.totalAdditional != null)
  ) {
    return nested
  }

  return response
}
